import { useInternalMetrics } from '../../queries/internal'
import CenteredLoadingAnimation from '../core/CenteredLoadingAnimation'
import Text from '../core/Text/Text'

const InternalDashboard = () => {
  const { data, isLoading, isError } = useInternalMetrics()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
        padding: '10px 15px 10px 15px'
      }}
    >
      <div style={{ paddingBottom: '20px' }}>
        <h3>Metrics!</h3>
        {isError && (
          <Text size="20" css={{ color: 'red' }}>
            Something went wrong!
          </Text>
        )}
        {isLoading ? (
          <CenteredLoadingAnimation />
        ) : (
          <>
            <p style={{ marginBottom: '0', paddingBottom: '0' }}>
              Profiles created in the last 7 days: {data.userCreatedLastSevenDays}
            </p>
            <p style={{ marginBottom: '0', paddingBottom: '0' }}>
              Profiles that saved drafts in the last 7 days: {data.profilesSavedDraftsLastSevenDays}
            </p>
            <p>Profiles that minted in the last 7 days: {data.profilesMintedSongsLastSevenDays}</p>
            <p style={{ marginBottom: '0', paddingBottom: '0' }}>
              Total media connections (sum of all subcomponents): {data.totalSubComponents}
            </p>
          </>
        )}
      </div>
    </div>
  )
}

export default InternalDashboard
